import { colors, fonts } from '@grupoboticario/flora-tokens/boticario/web/ds'

export const boticario = {
  colors,
  fonts,
}
